export default "__VITE_ASSET__DFC5I4CI__"